import { defineMessages } from '../define';

/** The overview screen: metric tiles, the volume chart and its side panels. */
export const dashboard = defineMessages({
  en: {
    'dashboard.title': 'Overview',
    'dashboard.hostUp': 'Host up',
    'dashboard.live': 'Live',
    'dashboard.paused': 'Paused',

    'dashboard.rangeLabel': 'Chart range',
    'dashboard.range.24h': '24h',
    'dashboard.range.7d': '7d',

    'dashboard.tile.connected': 'Connected sessions',
    'dashboard.tile.connectedHint': '{count} total',
    'dashboard.tile.inbound': 'Inbound today',
    'dashboard.tile.outbound': 'Outbound today',
    'dashboard.tile.queue': 'Queue backlog',
    'dashboard.tile.queueHint': '{count} delayed',
    'dashboard.tile.failedWebhooks': 'Failed webhooks 24h',
    'dashboard.tile.deadLetters': 'Dead letters',

    'dashboard.volume.title': 'Message volume',
    'dashboard.volume.hourly': 'Hourly buckets, last 24 hours',
    'dashboard.volume.daily': 'Daily buckets, last 7 days',
    'dashboard.series.inbound': 'Inbound',
    'dashboard.series.outbound': 'Outbound',

    'dashboard.sessions.title': 'Sessions',
    'dashboard.sessions.all': 'All',
    'dashboard.sessions.empty': 'No sessions yet.',

    'dashboard.host.title': 'Host',
    'dashboard.host.memory': 'Memory',
    'dashboard.host.load': 'Load',
    'dashboard.host.instances.one': '{count} instance',
    'dashboard.host.instances.other': '{count} instances',

    'dashboard.topChats.title': 'Busiest chats',
    'dashboard.topChats.description': 'Today, across every session',
    'dashboard.topChats.empty': 'No messages today.',
    'dashboard.column.chat': 'Chat',
    'dashboard.column.type': 'Type',
    'dashboard.column.messages': 'Messages',

    'dashboard.activity.title': 'Recent activity',
    'dashboard.activity.description': 'Live console output',
    'dashboard.activity.all': 'All logs',
    'dashboard.activity.empty': 'Waiting for the next line. Anything the workers log shows up here.',
  },
  th: {
    'dashboard.title': 'ภาพรวม',
    'dashboard.hostUp': 'โฮสต์ทำงานมาแล้ว',
    'dashboard.live': 'สด',
    'dashboard.paused': 'หยุดชั่วคราว',

    'dashboard.rangeLabel': 'ช่วงเวลาของกราฟ',
    'dashboard.range.24h': '24 ชม.',
    'dashboard.range.7d': '7 วัน',

    'dashboard.tile.connected': 'เซสชันที่เชื่อมต่ออยู่',
    'dashboard.tile.connectedHint': 'ทั้งหมด {count}',
    'dashboard.tile.inbound': 'ข้อความเข้าวันนี้',
    'dashboard.tile.outbound': 'ข้อความออกวันนี้',
    'dashboard.tile.queue': 'งานค้างในคิว',
    'dashboard.tile.queueHint': 'รอเวลา {count}',
    'dashboard.tile.failedWebhooks': 'Webhook ล้มเหลวใน 24 ชม.',
    'dashboard.tile.deadLetters': 'รายการ dead letter',

    'dashboard.volume.title': 'ปริมาณข้อความ',
    'dashboard.volume.hourly': 'รายชั่วโมง ย้อนหลัง 24 ชั่วโมง',
    'dashboard.volume.daily': 'รายวัน ย้อนหลัง 7 วัน',
    'dashboard.series.inbound': 'ข้อความเข้า',
    'dashboard.series.outbound': 'ข้อความออก',

    'dashboard.sessions.title': 'เซสชัน',
    'dashboard.sessions.all': 'ทั้งหมด',
    'dashboard.sessions.empty': 'ยังไม่มีเซสชัน',

    'dashboard.host.title': 'เครื่องเซิร์ฟเวอร์',
    'dashboard.host.memory': 'หน่วยความจำ',
    'dashboard.host.load': 'โหลดเฉลี่ย',
    'dashboard.host.instances.one': '{count} อินสแตนซ์',
    'dashboard.host.instances.other': '{count} อินสแตนซ์',

    'dashboard.topChats.title': 'แชทที่คึกคักที่สุด',
    'dashboard.topChats.description': 'วันนี้ จากทุกเซสชัน',
    'dashboard.topChats.empty': 'วันนี้ยังไม่มีข้อความ',
    'dashboard.column.chat': 'แชท',
    'dashboard.column.type': 'ประเภท',
    'dashboard.column.messages': 'ข้อความ',

    'dashboard.activity.title': 'ความเคลื่อนไหวล่าสุด',
    'dashboard.activity.description': 'เอาต์พุตจากคอนโซลแบบเรียลไทม์',
    'dashboard.activity.all': 'ดูบันทึกทั้งหมด',
    'dashboard.activity.empty': 'กำลังรอบรรทัดถัดไป ทุกอย่างที่ worker บันทึกไว้จะปรากฏที่นี่',
  },
});
